if($('.news-item-detail').length){
  if ($('.news-item-detail .text ul[style="list-style-type: square;"]').length > 0) {
  var apiUrl = "https://php.shopcode.cz/api/zahradnictvi-spomysl-Hu/api-product-list.php";
  $('.news-item-detail .text ul[style="list-style-type: square;"]').each(function (index) {
    var $ul = $(this);
    $ul.hide();
    var codes = [];
    $ul.find('li').each(function () {
      var code = $(this).text().trim();
      if (code) codes.push(code);
    });
    if (codes.length === 0) return;

    $.ajax({
      url: apiUrl,
      type: "GET",
      data: {
        codes: codes.join(',')
      },
      dataType: "json",
      success: function (response) {

  if (!Array.isArray(response) || response.length === 0) return;

  const $productPostsWrap = $(`
    <div class="postsProducts postsProducts-${index}">
      <div class="products products-page products-block"></div>
    </div>
  `);

  $ul.after($productPostsWrap);

  const ordered = codes
    .map(code => response.find(item => String(item.code) === String(code)))
    .filter(Boolean);

  const isSingle = ordered.length === 1;

  ordered.forEach(item => {
    const nameEscaped = escapeHtmlAttr(item.name);
    const shortDesc = item.short_description
    ? htmlToText(item.short_description)
    : '';
    const price = Number(item.price);
    const standardPrice = item.standard_price !== null
      ? Number(item.standard_price)
      : null;
    const detailHtml = `
      <div class="product ${isSingle ? 'single-product' : ''}" data-code="${item.code}">
        <div class="p">
          <a href="${item.orig_url}" class="image">
            <img src="${item.image.replace('/orig/', '/detail/')}" alt="${nameEscaped}">
          </a>

          <div class="p-in">
          <div class="p-in-in">
              <a href="${item.orig_url}" class="name" data-micro="url" tabindex="0">
                    <span data-micro="name" data-testid="productCardName">
                      ${item.name}
                      ${item.appendix ? `
                      <span class="product-appendix">
                        ${item.appendix}
                      </span>
                    ` : ''}
                    </span>
                </a>
          </div>
            
          <div class="p-bottom">
            <div>
            ${shortDesc ? `
              <div class="p-desc">
                ${shortDesc}
              </div>
            ` : ''}
              
            <div class="prices">
              ${
              standardPrice && standardPrice > price
                ? `
                  <span class="price-standard">
                    <span>${standardPrice.ShoptetFormatAsCurrency()}</span>
                  </span>
                `
                : ''
            }

            <div class="price price-final" data-testid="productCardPrice">
              <strong>${price.ShoptetFormatAsCurrency()}</strong>
              <span class="pr-list-unit">/&nbsp;${translation('ks')}</span>
            </div>
            </div>
            <div class="p-tools">
              <a href="${item.orig_url}" class="btn btn-primary" aria-hidden="true" tabindex="0">Detail</a>
            </div>

          </div>
            </div>
          </div>
        </div>
      </div>
    `;

    $productPostsWrap.find('.products').append(detailHtml);
  });

  // 🔹 SLICK jen pokud je víc produktů
if (!isSingle) {

  $productPostsWrap.find('.products').each(function () {

    const $products = $(this);

    // pojistka – ať se slick neinicializuje 2×
   

    // najdeme NADPIS – může být přes <ul>, proto prevAll
    const $heading = $products
      .closest('.postsProducts')
      .prevAll('h4')
      .first();



    // přidáme container na šipky (jen jednou)
    if (!$heading.find('.brandArrows').length) {
      $heading.addClass('products-related-header').append('<span class="brandArrows"></span>');
    }

    const $arrows = $heading.find('.brandArrows');

    $products.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 5000,
      dots: true,
      arrows: true,
      infinite: false,
      adaptiveHeight: false,
      appendArrows: $arrows,
      responsive: [
        { breakpoint: 1199, settings: { slidesToShow: 3 } },
        { breakpoint: 991,  settings: { slidesToShow: 2 } },
        { breakpoint: 767,  settings: { slidesToShow: 2, dots: false } },
        { breakpoint: 330,  settings: { slidesToShow: 1, dots: false } }
      ]
    });

  });

}

},


      error: function (xhr, status, error) {
        console.error("Chyba při volání API:", error);
      }
    });
  });

  function escapeHtmlAttr(text) {
    return text
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }
}

}


function htmlToText(html) {
  if (!html) return '';
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent.trim();
}